module.exports = __webpack_public_path__ + "img/134.bc96d538.jpg";